module.exports = __webpack_public_path__ + "assets/img/186101.9bb48670.png";